/*
包含多个基于state的getter计算属性的对象
 */

export default {

}



// WEBPACK FOOTER //
// ./src/store/getters.js